import * as React from 'react';

/**
 * Scroll a highlighted calendar event into view.
 *
 * The event's DOM node is owned by DraggableEvent, which does not forward a ref, but it
 * does render a stable data-testid. Looking the node up by that testid keeps this out of
 * the drag machinery. Mirrors the scrollIntoView behaviour of the unscheduled sidebar.
 */
const useHighlightScroll = (scheduleId, isHighlighted) => {
  React.useEffect(() => {
    if (!isHighlighted || !scheduleId) return undefined;

    // Let the grid finish laying out after the calendar refetch before scrolling.
    const timer = setTimeout(() => {
      const node = document.querySelector(`[data-testid="calendar-event-${scheduleId}"]`);
      if (node) {
        node.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [scheduleId, isHighlighted]);
};

export default useHighlightScroll;
